// How often `elapsed` updates while running, in ms
const TICK_MS = 200

export class StopWatch {
	status = $state<'reset' | 'running' | 'paused'>('reset')
	// Milliseconds
	elapsed = $state(0)
	#lastTick = 0
	#interval: Nullable<ReturnType<typeof setInterval>> = null

	get isRunning() {
		return this.status === 'running'
	}

	start() {
		this.reset()
		this.#run()
	}

	pause() {
		this.#stop()
		this.status = 'paused'
	}

	reset() {
		this.#stop()
		this.elapsed = 0
		this.status = 'reset'
	}

	toggle() {
		if (this.isRunning) {
			this.pause()
		} else {
			this.#run()
		}
	}

	#run() {
		this.#stop()
		this.#lastTick = Date.now()
		this.status = 'running'
		this.#interval = setInterval(() => {
			const now = Date.now()
			this.elapsed += now - this.#lastTick
			this.#lastTick = now
		}, TICK_MS)
	}

	#stop() {
		if (this.#interval) {
			clearInterval(this.#interval)
			this.#interval = null
		}
	}
}
